export default [
  {
    path: '/perfil',
    name: 'Profile',
    component: () => import('@/views/adm/modules/Profile.vue'),
    meta: {
      title: "Perfil"
    }
  },
]
